<template>
  <div class="workBench-protocolTab" v-if="arrShow[0]||arrShow[1]">
   <!-- 协议tab -->
  
    <el-tabs v-model="activeName" @tab-click="tabClick" v-if="arrShow[0]">
      <el-tab-pane label="复星战略协议" name="1" >
        <el-table
          class="sort-tabel"
          v-loading = "itemLoading"
          element-loading-text = "加载中..."
          element-loading-spinner = "el-icon-loading"
          :data="tableData"
          style="width: 100%"
          :default-sort = "{prop: 'name', order: 'descending'}"
          >
          <el-table-column
            prop="brandName"
            label="品牌名称"
            width="180" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="供应品类"
            width="180" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="protocolName"
            label="协议名称" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="protocolName-col" @click="toProtocol(scope.row.protocolURL)">{{scope.row.protocolName}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="display:flex;justify-content:flex-end;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="万邦集团协议" name="2" v-if="arrShow[1]">
        
        <el-table
          v-loading = "itemLoading"
          element-loading-text = "加载中..."
          element-loading-spinner = "el-icon-loading"
          :data="tableData"
          style="width: 100%"
          :default-sort = "{prop: 'name', order: 'descending'}"
          >
          <el-table-column
            prop="protocolName"
            label="协议名称">
            <template slot-scope="scope">
              <span class="protocolName-col" @click="toProtocol2(scope.row.protocolURL)">{{scope.row.protocolName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="protocolType"
            label="协议类型"
            width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.protocolType|getProtocolType}}
            </template>
          </el-table-column>
          <el-table-column
            prop="address"
            width="120"
            label="协议有效期" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.effectiveDate|timeDate}}
            </template>
          </el-table-column>
          <el-table-column
            prop="statusName"
            width="80"
            label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.statusName|getProtocolStatus}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="display:flex;justify-content:flex-end;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import tag from './tag.vue'
import classTag from './classTag.vue'
export default {
  props: [],
  components: {
    'tag' : tag,
    'classTag' : classTag,
  },
  data () {
    return {
      activeName:'1',
      pageNo:1,
      pageSize:10,
      total: 0,
      tableData: [],
      itemLoading:false,
      arrShow:[true,true]
    }
  },
  mounted () {
    this.allProtocol()
  },
  computed: mapState([
    'KP'
  ]),
  methods: {
    tabClick(val){
      // console.info(val)
      this.total=0
      this.pageNo=1
      this.getList()
    },
    // 获取列表
    getList(){

      if(this.activeName==1){
        this.loadFosunProtocol()
      }else{
        this.loadWbangProtocol()
      }
    },
		handleSizeChange(val) {

      this.pageSize=val
      this.getList()
		},
		handleCurrentChange(val) {
      this.pageNo=val
      this.getList()
    },
    // 设置数据
    setList(data,cb){
      // console.info(data)
      this.tableData=[]
      this.itemLoading = false
      if (data.code == 0) {
        // this.tableData = data.rows||[]
        this.$set(this,'tableData',data.rows||[])
        if(this.activeName=='1'){
          this.total=Number(data.msg)
        }else{
          this.total=Number(data.pageInfo.totalRecords)
        }
      } else {
        this.tableData=[]
        // this.$message.error(data.errorMsg);
      }
      
    },
    // /card/loadWbangProtocol万邦协议
    loadWbangProtocol (cb) {
      this.itemLoading = true
      return this.$axios
        .post('/onelink.mdata.main.api/card/loadWbangProtocol', {
          pageSize:this.pageSize,
          pageNumber:this.pageNo
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // POST /card/loadFosunProtocol 复星战略协议
    loadFosunProtocol (cb) {
      this.itemLoading = true
     return this.$axios
        .post('/onelink.mdata.main.api/card/loadFosunProtocol', {
          pageSize:this.pageSize,
          pageNumber:this.pageNo
        })
        .then(res => {
          this.setList(res.data,cb)
        })
        .catch(err => {
          console.log(err);
        });
    },
    allProtocol(){
      
      this.itemLoading = true
      this.$axios
        .all([this.$axios
        .post('/onelink.mdata.main.api/card/loadFosunProtocol', {
          pageSize:this.pageSize,
          pageNumber:this.pageNo
        }),this.$axios
        .post('/onelink.mdata.main.api/card/loadWbangProtocol', {
          pageSize:this.pageSize,
          pageNumber:this.pageNo
        })])
        .then(this.$axios.spread((res1,res2)=>{
          this.itemLoading = false
          // console.info(res1,res2)
          if(res1.data.code==0&&res2.data.code==0){
            this.activeName='1'
            this.setList(res1.data)
          }else if(res1.data.code==0&&res2.data.code!=0){
            this.activeName='1'
            this.setList(res1.data)
          }else if(res1.data.code!=0&&res2.data.code==0){
            this.activeName='2'
            this.setList(res2.data)
          }else{
            this.$set(this,'arrShow',[false,false])
          }

          if(res1.data.code==0){
            // this.setList(res1.data)
          }else{
            this.arrShow[0]=false
            this.$set(this,'arrShow',this.arrShow)
          }
          if(res2.data.code==0){
            
            // this.setList(res2.data)
          }else{
            this.arrShow[1]=false
            this.$set(this,'arrShow',this.arrShow)
          }
        }));
    },
    toProtocol(url){
      
      let userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
      let companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
      this.$axios.post('/onelink.mdata.main.api/recruitInfo/checkHasViewDataAuth?userId='+userInfo.id+"&currentOrgId="+companyInfo.orgId, {
      }).then((res) => {
        this.loading=false;
        this.data = res.data;
        if(this.data){
          // this.directUrl = '/recruit?redirctUtl='+viewProtocolDetailUrl + protocolId;
          // if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)){
          //   this.$router.push({path:'/recruit', query: {  redirctUtl: viewProtocolDetailUrl + protocolId }})
          // }else{
          //   let routeData = this.$router.resolve({ path: '/recruit', query: {  redirctUtl: viewProtocolDetailUrl + protocolId } });
          //   window.open(routeData.href, '查看协议信息');
          // }
          
          window.open(url, '_blank')
          // this.$router.push({path:this.directUrl});
          // let newWin = window.open("about:blank",'查看采购协议','width='+ (window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ ',top=0,left=0,resizable=yes,status=yes,menubar=no,scrollbars=yes');
          // newWin.location.href=viewProtocolDetailUrl + protocolId;
          // window.open(viewProtocolDetailUrl + protocolId,'查看协议信息','width='+ (window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ ',top=0,left=0,resizable=yes,status=yes,menubar=no,scrollbars=yes');
          // window.location.href = viewProtocolDetailUrl + protocolId;
        }else{
          this.$alert('<p>很抱歉，您没有访问权限…</p>', '', {
            dangerouslyUseHTMLString: true,
            customClass:'mobileText',
            center: true
          });
        }
      }).catch((err) => {
        console.log(err)
      })
      // window.open(url, '_blank')
    },
    toProtocol2(url){
      window.open(url, '_blank')
    }
  }
}
</script>
<style>
.workBench-protocolTab .mr15{
  margin-right: 15px;
}
.workBench-protocolTab .mb15{
  margin-bottom: 15px;
}
.workBench-protocolTab .mr5{
  margin-right: 5px;
}
.workBench-protocolTab{
  background:#fff;
  padding:15px;
  border-radius: 5px;
  border-radius: 5px;
  flex-shrink: 1;
}
.workBench-protocolTab .tab-list{
  display: flex;
  flex-wrap: wrap;
}
.workBench-protocolTab .tab-item{
  width: 33%;
  background: #fff;
  padding: 20px 15px;
  border-right: 1px solid #E6E8EB;
}
.workBench-protocolTab .tab-item:nth-child(n+3){
  border-right: 0;
}
.workBench-protocolTab .tab-item:nth-child(1){
  border: 1px solid #E6E8EB;
}
.workBench-protocolTab .tab-item:nth-child(2){
  border: 1px solid #E6E8EB;
}
.workBench-protocolTab .tab-item:nth-child(3){
  border: 1px solid #E6E8EB;
}
.workBench-protocolTab .tab-item-p1{
  font-size: 14px;
  color: #303133;
  line-height: 18px;
}
.workBench-protocolTab .tab-item-p2{
  font-size: 12px;
  color: #909399;
  line-height: 18px;
}
.workBench-protocolTab .tab-item-p3{
  font-size: 12px;
  color: #303133;
  line-height: 18px;
}
.workBench-protocolTab .protocolTab-page {
  text-align: right;
}
.workBench-protocolTab .protocolTab-page .btn-prev,.workBench-protocolTab .protocolTab-page .btn-next{
  margin-left: 10px;
  padding-right: 10px;
  padding-left: 10px;
  color:#606266;
  font-size: 12px;
  font-weight: normal;
  line-height: 30px;
  height: 30px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  border-radius: 4px;
}
.workBench-protocolTab .protocolTab-page button:hover {
    color: #2E8AF1;
}
.workBench-protocolTab .protocolTab-page button:disabled {
    color: #C0C4CC;
    background-color: #FFF;
    cursor: not-allowed;
}

.workBench-protocolTab .el-table .el-table__header th, .workBench-protocolTab .el-table .el-table__header tr{
  background: #F0F2F5;
  padding-top: 7px;
  padding-bottom: 7px;
}
.workBench-protocolTab .sort-tabel .el-table__header th, .workBench-protocolTab .sort-tabel .el-table__header tr{

  padding-top: 7px;
  padding-bottom: 7px;
}
.workBench-protocolTab .el-table{
    margin-top: 0;
    font-size: 12px;
    margin-bottom: 15px;
}
.workBench-protocolTab .el-table .el-table__body-wrapper tr.el-table__row td{
      padding: 0;
}
.workBench-protocolTab .el-table__body-wrapper .el-dialog__body .el-table .el-table__body-wrapper tr.el-table__row td{
  padding: 0;
}
.workBench-protocolTab .el-table__body-wrapper p{
  margin: 0;
}
.workBench-protocolTab .el-table__body-wrapper .el-dialog__body .el-table{
  margin: 0;
}   
.workBench-protocolTab .el-table__body-wrapper tr{
  padding-top: 0;
  padding-bottom: 0;
}

.workBench-protocolTab .el-table__body-wrapper td,.workBench-protocolTab .el-table__body-wrapper th{
  padding-top: 0px;
  padding-bottom: 0px;
}
.workBench-protocolTab .el-table__body-wrapper .cell{
  line-height: 24px;
  padding-top: 6px;
  padding-bottom:6px;
} 
.workBench-protocolTab .el-pagination{
  font-weight: normal;
}
.workBench-protocolTab .el-tabs__header{
  margin-bottom: 0;
}
.workBench-protocolTab .el-tabs__item:hover {
    color: #2E8AF1;
    cursor: pointer;
}

.workBench-protocolTab .el-tabs__item.is-active {
    color: #2E8AF1;
  font-weight: bold;
}
.workBench-protocolTab .el-tabs__active-bar {
  background-color: #2E8AF1;
}
.workBench-protocolTab .protocolName-col{
  color:#2E8AF1;
}
.workBench-protocolTab .protocolName-col:hover{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/protocolTab.vue